<template>
  <section class="price" id="price">
    <div class="container">
      <h2 class="heading">Наши цены</h2>
      <div class="content">
        <ul class="list">
          <li class="item">
            <span class="item-category">Легковые/Мото: </span>
          </li>
          <li class="item">
            <span class="item-title">Мойка кузова</span>
            <span class="item-amount">350&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Трехфазная наномойка кузова</span>
            <span class="item-amount">650&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Мойка ковриков</span>
            <span class="item-amount">100&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Влажная чистка торпедо и обшивок дверей</span>
            <span class="item-amount">150&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Мойка стекол</span>
            <span class="item-amount">150&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Чистка салона пылесосом</span>
            <span class="item-amount">150&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Чистка багажника</span>
            <span class="item-amount">150&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Двухфазная наномойка</span>
            <span class="item-amount">550&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Мойка мотоцикла</span>
            <span class="item-amount">300&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Химчистка дисков</span>
            <span class="item-amount">500&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Чернение резины</span>
            <span class="item-amount">150&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Холодный воск</span>
            <span class="item-amount">150&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Горячий воск</span>
            <span class="item-amount">300&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Твердый воск</span>
            <span class="item-amount">1500&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Нано воск</span>
            <span class="item-amount">400&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Полимер</span>
            <span class="item-amount">400&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Кондиционер кожи</span>
            <span class="item-amount">300&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Полироль пластика</span>
            <span class="item-amount">150&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Мойка двигателя</span>
            <span class="item-amount">500&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Техническая мойка</span>
            <span class="item-amount">200&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Комплексная мойка</span>
            <span class="item-amount">600&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Нано комплекс</span>
            <span class="item-amount">1100&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Удаление битума</span>
            <span class="item-amount">1000&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Антидождь для стекол</span>
            <span class="item-amount">1000&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Полировка кузова 1 деталь</span>
            <span class="item-amount">500&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Полировка фар</span>
            <span class="item-amount">800&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Полировка хрома</span>
            <span class="item-amount">300&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Химчистка салона</span>
            <span class="item-amount">6000&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Кварцевое покрытие</span>
            <span class="item-amount">700&#8381;</span>
          </li>
        </ul>

        <ul class="list" style="margin-top: 10px;">
          <li class="item">
            <span class="item-category">Коммерческие - мойка снаружи:</span>
          </li>
          <li class="item">
            <span class="item-title">Легковой фургон\каблук</span>
            <span class="item-amount">400&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Одиночка бортовая</span>
            <span class="item-amount">1200&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Самосвал большой</span>
            <span class="item-amount">1800&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Кран большой\малый</span>
            <span class="item-amount">1600&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Бетономешалка</span>
            <span class="item-amount">1800&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Автобус междугородний</span>
            <span class="item-amount">1800&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Автобус малый</span>
            <span class="item-amount">1000&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Седельный тягач (бескапотный, короткий спальник)</span>
            <span class="item-amount">700&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Полуприцеп отдельно</span>
            <span class="item-amount">1200&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Еврофура (тягач + полуприцеп)</span>
            <span class="item-amount">1500&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Американская фура (тягач + полуприцеп)</span>
            <span class="item-amount">1600&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Сцепка (одиночка + полуприцеп)</span>
            <span class="item-amount">1800&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Цистерна (тягач + платформа)</span>
            <span class="item-amount">1600&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Одиночка 7 тонн</span>
            <span class="item-amount">1200&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Одиночка от 4 до 7 тонн</span>
            <span class="item-amount">1000&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Одиночка от 2 до 4 тонн</span>
            <span class="item-amount">800&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Газель \ портер</span>
            <span class="item-amount">600&#8381;</span>
          </li>
          <li class="item">
            <span class="item-category" style="margin-top: 10px">Коммерческие - мойка внутри :</span>
          </li>
          <li class="item">
            <span class="item-title">Легковой фургон\каблук</span>
            <span class="item-amount">200&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Одиночка бортовая</span>
            <span class="item-amount">900&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Самосвал большой</span>
            <span class="item-amount">1000&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Еврофура (тягач + полуприцеп)</span>
            <span class="item-amount">1000&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Американская фура (тягач + полуприцеп)</span>
            <span class="item-amount">1000&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Сцепка (одиночка + полуприцеп)</span>
            <span class="item-amount">1000&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Цистерна (тягач + платформа)</span>
            <span class="item-amount">900&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Одиночка 7 тонн</span>
            <span class="item-amount">700&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Одиночка от 4 до 7 тонн</span>
            <span class="item-amount">600&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Одиночка от 2 до 4 тонн</span>
            <span class="item-amount">500&#8381;</span>
          </li>
          <li class="item">
            <span class="item-title">Газель \ портер</span>
            <span class="item-amount">300&#8381;</span>
          </li>
        </ul>
      </div>
    </div>
  </section>    
</template>

<style scoped>
.price {
  font-size: 18px;
  background-color: #e9e9e9a6;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 18px;
  max-width: 60%;
  margin: 0 auto;


}

.item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;
  align-items: center;
}

.item-title {
  max-width: 350px;
  margin-right: 20px;
}

.item-category {
  font-size: 25px;
  font-weight: bolder;
  margin-bottom: 10px;
  display: block;
  border-bottom: 1px solid;
  padding-bottom: 10px;
  width: 100%;
}

@media screen and (max-width: 580px) {
  .content {
    max-width: 85%;
  } 
}
@media screen and (max-width: 450px) {
  .content {
    max-width: 95%;
  } 
}

</style>